import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const TeamLeaveStatusReport = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Team Leave Status Report"));
    fetchTeamLeaveReport();
  }, []);

  const [Teamleave, setTeamLeave] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterFormData, setFilterData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [respStatus, setRepStatus] = useState(0);
  const [apiStatus, setApiStatus] = useState('');

  const columns = {
    EmployeeName: { text: "Employee", align: "start", visible: "true" },
    LeaveType: { text: "Leave", visible: "true", align: "center" },
    LeaveAccrued: { text: "Accrued", align: "center", visible: "true" },
    LeaveApplied: { text: "Applied", align: "center", visible: "true" },
    LeaveApproved: { text: "Approved", align: "center", visible: "true" },
    LeaveBalance: { text: "Balance", align: "center", visible: "true" },
  };

  const formDatas = [
    { name: "Employee", type: "Select", options: [...employeeList] },
    { name: "Leave", type: "Select", options: [...monthList] },
  ];

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e,
          },
        ];
      }
    });
  };

  const fetchTeamLeaveReport = async (employeeId = 0, leaveId = 0) => {
    setApiStatus(undefined)
    // setTeamLeave([])
    try {
      const response = await GetServiceCaller(
        `${API_URL}leave-reports/1?P_EmployeeID=${employeeId}&P_LeaveID=${leaveId}`
      );
      
      setApiStatus(response?.status);
      if (response.status === 200) {
        setTeamLeave(response?.data?.header || []);

        const employeeList = response?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.Name,
        }));
        setEmployeeList(employeeList || []);

        const monthlist = response?.data?.leave?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setMonthList(monthlist || []);
        setRepStatus(response.status);
      } else {
        console.error("Failed to fetch Leave:", response.status);
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const handleGetData = () => {
    const employeeId = filterFormData.find((o) => o.label === "Employee")?.value || 0;
    const leaveId = filterFormData.find((o) => o.label === "Leave")?.value || 0;
    fetchTeamLeaveReport(employeeId, leaveId);
  };

  const handleFilterReset = () => {
    setFilterData([]);
    fetchTeamLeaveReport(); // This will call with default values (0, 0)
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
          <Dynamic_PR_table
            data={Teamleave}
            columns={columns}
            itemsPerPage={8}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            showIcon1={true}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            showIcon2={false}
            showIcon3={false}
            isSorting={true}
            showIcon4={true}
            showIcon5={false}
            formDatas={formDatas}
            filterFormData={filterFormData}
            handleGetData={handleGetData}
            isActionRequired={false}
            isFilterRequired={true}
            isCheckBoxRequired={false}
            handleReset={handleFilterReset}
            handleChange={handleChange}
            add
            more
            function
            icons={{
              Icon1: <i className="bi bi-pencil-square icons"></i>,
              Icon2: <i className="bi bi-trash-fill icons"></i>,
              Icon3: <i className="bi bi-eye-fill icons"></i>,
              Icon4: <i className="bi bi-person-plus icons"></i>,
              Icon4Text: "Create Employee",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TeamLeaveStatusReport;